import "./base.js";
import "../../components/thumbnail_editor.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Modal ??= {};

Sparkle.PageBuilder.Modal.SlideEditor = class SlideEditor extends Sparkle.PageBuilder.Modal.Base {
  constructor(slide, editorFields, options) {
    super(options);
    this.render = this.render.bind(this);
    this.renderImagePanel = this.renderImagePanel.bind(this);
    this.renderMetadataPanel = this.renderMetadataPanel.bind(this);
    this.getOutput = this.getOutput.bind(this);
    this.slide = slide;
    this.editorFields = editorFields;
    if (options == null) {
      options = {};
    }

    this.imagePanel = this.modal.container.find(".image-panel");
    this.metadataPanel = this.modal.container.find(".metadata-panel");
    this.thumbnailEditor = new ThumbnailEditor({ pageType: options.pageType });
  }

  // RENDERING

  render() {
    this.renderImagePanel();
    this.renderMetadataPanel();

    return this;
  }

  renderImagePanel() {
    this.imagePanel.append(this.thumbnailEditor.render().el);
    if (this.slide.url) {
      this.thumbnailEditor.setTab("Edit");
      this.thumbnailEditor.setThumbnail({
        cropSettings: this.slide.crop_settings,
        originalUrl: `/admin/assets/${this.slide.id}`,
      });
    } else {
      this.thumbnailEditor.setTab("Library");
    }

    return this;
  }

  renderMetadataPanel() {
    this.metadataPanel.find(".editor-fields-container").append(this.editorFields);

    return this;
  }

  getOutput() {
    const thumbnail = this.thumbnailEditor.getThumbnail();
    if (thumbnail.assetId) {
      this.slide.id = thumbnail.assetId;
    } // If the asset ID was updated, assign it
    if (this.slide.isVideo) {
      if (thumbnail.assetUrl) {
        this.slide.url = thumbnail.assetUrl;
      }
    } else if (thumbnail.originalUrl) {
      this.slide.url = thumbnail.originalUrl;
    }
    if (thumbnail.originalUrl) {
      this.slide.hi_res_url = thumbnail.originalUrl;
    }
    this.slide.crop_settings = thumbnail.cropSettings;
    return this.slide;
  }
};
Sparkle.PageBuilder.Modal.SlideEditor.prototype.template = "slideshow-dialog";
Sparkle.PageBuilder.Modal.SlideEditor.prototype.title = "Edit Slide";
Sparkle.PageBuilder.Modal.SlideEditor.prototype.class = "admin-modal slideshow-editor-modal";
